/**
 * Setup do interceptor global do fetch
 *
 * Este arquivo sobrescreve o fetch nativo do browser para adicionar
 * renovação automática de token em todas as requisições HTTP.
 */

import { fetchWithAuth } from './fetchWithAuth';

export function setupFetchInterceptor() {
  // Salvar referência ao fetch original
  const originalFetch = window.fetch;

  // Sobrescrever o fetch global
  window.fetch = function(...args: Parameters<typeof fetch>): Promise<Response> {
    // Chamar nossa função com renovação automática de token
    return fetchWithAuth(args[0], args[1]);
  } as typeof fetch;

  console.log('[setupFetchInterceptor] Interceptor global do fetch configurado');

  // Retornar função para restaurar o fetch original (útil para testes)
  return () => {
    window.fetch = originalFetch;
    console.log('[setupFetchInterceptor] Fetch original restaurado');
  };
}
